import React, {useState, useEffect} from "react";
import { connect } from 'react-redux'
import stateMap from "store/stateMap";
import api from "api";
import _ from "lodash";
import { Waypoint } from 'react-waypoint';
import update from 'immutability-helper';
import {InitiativeUpdates, InitiativeUpdatesForm} from "component/Updates";
import "./index.scss";
import { PageCredential } from "component/PageCredential";

const PageInsideInitiativeUpdates = connect(stateMap)((props) => {

    const[updates, setUpdates]                              = useState(false);
    const[updatesTotal, setUpdatesTotal]                    = useState(false);
    const[paged, setPaged]                                  = useState(1);
    const[fetchingUpdates, setFetchingUpdates]              = useState(false);
    const[showCreateForm, setShowCreateForm]                = useState(false);

    const PaginationTalk = () => {

        if(fetchingUpdates)
        {
            return;
        }

        if(!props.auth.user)
        {
            return;
        }

        setFetchingUpdates(true);

        var Promises = [
            api('/Initiative/Updates', 'get', {
                paged               : paged
                ,posts_per_page     : 3
                ,initiative_id      : props.initiative.initiative.InitiativeID
            }, 'Bearer ' + props.auth.token)
            ,api('/Initiative/Updates', 'get', {
                get_total           : 1
                ,initiative_id      : props.initiative.initiative.InitiativeID
            }, 'Bearer ' + props.auth.token)
        ];

        Promise.all(Promises).then(function(response){
            let ResponseUpdates = response[0];

            setUpdatesTotal(response[1].updates);
            
            if(ResponseUpdates.updates.length > 0)
            {
                setFetchingUpdates(false);

                var NewUpdates = _.map(ResponseUpdates.updates, function(updateItem){
                    updateItem.Paged = paged;

                    return updateItem;
                });

                if(updates !== false)
                {
                    setUpdates( updates.concat(NewUpdates));
                }
                else
                {
                    setUpdates(NewUpdates);
                }

                setPaged(paged + 1);

            }
            else
            {
                if(paged == 1)
                {
                    setUpdates([]);
                }
                
                setFetchingUpdates('EOF');
            }
        })
    }

    useEffect(PaginationTalk, [props.initiative.access]);

    return (
        props.initiative.access && 
        <div className="initiative-update-container container">
            <PageCredential title={`${props.initiative.initiative.Title} | Updates`} />
            <div className="w-800 mx-auto">
                {
                    props.initiative.access.membership && props.initiative.access.membership.MemberType == 'admin' && !showCreateForm && updates !== false &&
                    <div className="page-updates-intro-action rounded bg-white border-solid leading-text text-sm">
                        Communicate progress points regarding this initiative to colleagues and followers
                        <button className="btn btn-orange btn-small" onClick={(e) => {
                            e.preventDefault();

                            setShowCreateForm(true);

                        }}>Create Update</button>
                    </div>
                }
                {
                    props.initiative.access.membership && props.initiative.access.membership.MemberType == 'admin' && showCreateForm && updates !== false &&
                    <InitiativeUpdatesForm
                        initiative={props.initiative.initiative}
                        userToken={props.auth.token}
                        user={props.auth.user}
                        onSave={(updatesItem) => {
                            setUpdates(update(updates, {
                                $unshift : [updatesItem]
                            }));

                            setUpdatesTotal(updatesTotal + 1);

                            setShowCreateForm(false);
                        }}
                        onCancel={() => {
                            setShowCreateForm(false);
                        }}
                    />
                }
                <ul className="updates-lists mt-lg">
                    {
                        updates !== false && updates.length == 0 && 
                        <li className="updates-item mt-lg">
                            <span className="block text-center text-lg font-bold">
                                No updates at the moment
                            </span>
                        </li>
                    }
                    {
                        updates !== false && updates.map((updates, index) => {

                            return (
                                <li className="updates-item" key={updates.UpdatesID}>
                                    <InitiativeUpdates 
                                        updates={updates} 
                                        initiative={props.initiative.initiative} 
                                        user={props.auth.user} 
                                        userToken={props.auth.token}
                                    >
                                        <span className="updates-number">UPDATE #{updatesTotal - index}</span>
                                    </InitiativeUpdates>
                                </li>
                            )
                        })
                    }
                    {
                        fetchingUpdates !== 'EOF' && 
                        (
                            <Waypoint onEnter={PaginationTalk}  >
                                <li className="updates-item skeleton-updates mt-md">
                                {
                                    fetchingUpdates && <span className="skeleton"></span> 
                                }
                                </li>
                            </Waypoint>
                        )
                    }
                </ul>
                {
                    updates !== false && fetchingUpdates !== 'EOF' &&
                    <div className="text-center text-xs mt-md ">
                        Loading More Updates...
                    </div>
                }
            </div>

            
        </div>
    );
});

export default PageInsideInitiativeUpdates;